"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartTooltip = exports.ChartLegend = exports.ChartAxisLabel = void 0;
var React = __importStar(require("react"));
var Styled = __importStar(require("./ChartStyles"));
var body_1 = __importDefault(require("../body"));
var ChartAxisLabel = function (props) {
    var x = props.x, y = props.y, payload = props.payload, yAxis = props.yAxis, formatter = props.formatter, orientation = props.orientation;
    var value = payload.value;
    if (formatter) {
        value = formatter(value);
    }
    if (yAxis) {
        return (React.createElement("g", { transform: "translate(".concat(x, ",").concat(y, ")") },
            React.createElement(Styled.AxisLabelText, { x: 0, y: 0, dx: orientation === "right" ? 16 : -16, dy: 4, textAnchor: orientation === "right" ? "start" : "end", fill: "var(--steel)" }, value)));
    }
    else {
        return (React.createElement("g", { transform: "translate(".concat(x, ",").concat(y, ")") },
            React.createElement(Styled.AxisLabelText, { x: 0, y: 0, dy: 24, textAnchor: "middle", fill: "var(--steel)" }, value)));
    }
};
exports.ChartAxisLabel = ChartAxisLabel;
var ChartLegend = function (props) {
    var payload = props.payload, keys = props.keys;
    return (React.createElement(Styled.LegendContainer, null, payload.map(function (entry, index) {
        if (keys.includes(entry.dataKey)) {
            return (React.createElement(Styled.LegendItem, { key: "item-".concat(index) },
                React.createElement(Styled.LegendColorDot, { dotColorVar: entry.color }),
                React.createElement(Styled.LegendLabel, null, entry.value)));
        }
        else {
            return null;
        }
    })));
};
exports.ChartLegend = ChartLegend;
var ChartTooltip = function (props) {
    var active = props.active, payload = props.payload, keys = props.keys, xFormatter = props.xFormatter, yFormatter = props.yFormatter, xKey = props.xKey, chartType = props.chartType, currencySymbolValue = props.currencySymbolValue;
    if (active && payload && payload.length) {
        return (React.createElement(Styled.TooltipBase, null, chartType === "Pie" ? (React.createElement(Styled.TooltipItem, { key: "tooltip-item-" + payload[0].name },
            React.createElement(Styled.ColorIndicator, { color: payload[0].payload.fill }),
            React.createElement(Styled.TooltipItemLabelContainer, null,
                React.createElement(body_1.default, { withoutMargins: true, size: "xs" }, "Balance"),
                React.createElement(body_1.default, { size: "xxs", style: { color: "var(--smoke-darker)" }, withoutMargins: true }, payload[0].payload.name),
                React.createElement(Styled.ValueLabelContainer, null,
                    payload[0].payload.value.toFixed(2),
                    " ",
                    currencySymbolValue),
                React.createElement(body_1.default, { withoutMargins: true, size: "xs", style: {
                        display: "flex",
                        alignItems: "center",
                    } },
                    React.createElement(Styled.ValueLabelContainer, null,
                        payload[0].payload.percentage,
                        " %"),
                    React.createElement("span", { style: {
                            color: "var(--smoke-darker)",
                            paddingLeft: "0.4rem",
                        } }, "of total"))))) : (React.createElement(React.Fragment, null, payload.map(function (line, idx) {
            var keysObj = keys.find(function (obj) { return obj[xKey] === line.payload[xKey]; });
            var keysX = (keysObj === null || keysObj === void 0 ? void 0 : keysObj.keys) || [];
            if (keysX.includes(line.dataKey)) {
                return (React.createElement(Styled.TooltipItem, { key: "tooltip-item-" + idx },
                    React.createElement(Styled.ColorIndicator, { color: line.color }),
                    React.createElement(Styled.TooltipItemLabelContainer, null,
                        React.createElement(body_1.default, { withoutMargins: true, size: "xs" }, line.name),
                        xFormatter ? (React.createElement(body_1.default, { size: "xxs", style: { color: "var(--smoke-darker)" }, withoutMargins: true }, xFormatter(line.payload[xKey]))) : (React.createElement(body_1.default, { size: "xxs", style: { color: "var(--smoke-darker)" }, withoutMargins: true }, payload[xKey])),
                        yFormatter[keysX[idx]] ? (React.createElement(Styled.ValueLabelContainer, null, yFormatter[keysX[idx]](line.payload[keysX[idx]]))) : (React.createElement(Styled.ValueLabelContainer, null, line.payload[keysX[idx]])))));
            }
            else {
                return null;
            }
        })))));
    }
    return null;
};
exports.ChartTooltip = ChartTooltip;
